import { InjectionToken } from '@angular/core';
import dayjs from 'dayjs';
import localeData from 'dayjs/plugin/localeData';

dayjs.extend(localeData);

export const LOCALE_CONFIG = new InjectionToken<LocaleConfig>(
  'daterangepicker.config',
);

/**
 *  LocaleConfig Interface
 */
export interface LocaleConfig {
  direction?: string;
  separator?: string;
  weekLabel?: string;
  applyLabel?: string;
  cancelLabel?: string;
  clearLabel?: string;
  customRangeLabel?: string;
  daysOfWeek?: string[];
  monthNames?: string[];
  firstDay?: number;
  format?: string;
  displayFormat?: string;
  startDate?: string;
  endDate?: string;
}

/**
 *  DefaultLocaleConfig
 */
export const DefaultLocaleConfig: LocaleConfig = {
  direction: 'ltr',
  separator: ' - ',
  weekLabel: 'W',
  applyLabel: 'Confirmer',
  cancelLabel: 'Annuler',
  clearLabel: 'Effacer',
  customRangeLabel: 'Personnalisé',
  daysOfWeek: dayjs.weekdaysMin(),
  monthNames: dayjs.monthsShort(),
  firstDay: dayjs.localeData().firstDayOfWeek(),
};
